const state = () => ({
    entities: [],
    selectedEntity: null,
    preparedQueryId: null,
    layoutData: {},
    sidebar: {
        isSideBarVisible: false,
        component: null,
        properties: {},
        listeners: {},
        isActionsEnabled: false,
        actionButtons: [],
        closeCallback: () => { },
        isMoreFilterClicked: false
    },
    headerActions: [],
    preparedQueryFilters: {},
    assigneePreparedQueryId: null,
    routeHistory: [],
    loadingCounter: 0,
    isEntitiesWithAttributesLoaded: false
});

export default state;